import auth0 from 'auth0-js';
import AES from 'crypto-js/aes';
import Utf8 from 'crypto-js/enc-utf8';
import bronze from './../Assets/Images/bronze.png';
import sliver from './../Assets/Images/silver.png';
import gold from './../Assets/Images/gold.png';
import patinum from './../Assets/Images/platinum.png';
export const webAuth = new auth0.WebAuth({
  domain: process.env.REACT_APP_AUTH0_DOMAIN,
  clientID: `${process.env.REACT_APP_AUTH0}`,
  // scope: "read:current_user read:users_app_metadata update:users_app_metadata   update:current_user_metadata",
});
export const authentication = new auth0.Authentication({
  domain: process.env.REACT_APP_AUTH0_DOMAIN,
  clientID: `${process.env.REACT_APP_AUTH0}`,
});

export async function Auth0Logout() {
  const domain = process.env.REACT_APP_AUTH0_DOMAIN;
  const client_id = process.env.REACT_APP_AUTH0;
  const returnTo = window.location.origin;
  localStorage.removeItem('access_token');
  localStorage.removeItem('auth0-user');
  localStorage.removeItem('userMetadata');
  localStorage.removeItem('adminRole');
  cookieManager.deleteCookie('token');
  window.location.replace(
    `https://${domain}/v2/logout?returnTo=${returnTo}&client_id=${client_id}`
  );
}

export const cookieManager = {
  setCookie: (name, value, minutes) => {
    let expires = '';
    if (minutes) {
      const date = new Date();
      date.setTime(date.getTime() + minutes * 60 * 1000);
      expires = '; expires=' + date.toUTCString();
    }
    document.cookie = name + '=' + encodeURIComponent(value) + expires + '; path=/';
  },

  getCookie: name => {
    const nameEQ = name + '=';
    const cookies = document.cookie.split(';');
    for (let cookie of cookies) {
      cookie = cookie.trim();
      if (cookie.indexOf(nameEQ) === 0) {
        return decodeURIComponent(cookie.substring(nameEQ.length));
      }
    }
    return null;
  },

  deleteCookie: name => {
    document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/';
  },
};
export const extractId = url => {
  if (url?.includes('https://open.spotify.com/track/')) {
    const slashSplits = url.split('/');
    const songId = slashSplits[4].split('?')[0];
    return songId;
  } else if (url?.includes('spotify:track')) {
    const songId = url.split('spotify:track:')[1];
    return songId;
  } else {
    return url;
  }
};
export const getParams = name => {
  // Legacy alias — always reads campaign draft regardless of `name`
  try {
    const raw = localStorage.getItem('campaign-data');
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};
export const getEncryptedParam = name => {
  try {
    const url = new URL(window.location);
    let param = url?.searchParams?.get(name);
    let decryptedData = AES.decrypt(param, 'data');
    var originalText = decryptedData.toString(Utf8);
    if (param) {
      return JSON.parse(originalText);
    }
  } catch (err) {
    return null;
  }
};

export const getGreeting = () => {
  const currentHour = new Date().getHours();
  if (currentHour >= 6 && currentHour < 12) {
    return 'Good morning';
  } else if (currentHour >= 12 && currentHour < 18) {
    return 'Good afternoon';
  } else if (currentHour >= 18 || currentHour < 6) {
    return 'Good evening'; // Assuming evening covers 6 PM to 6 AM
  } else {
    return 'Hello'; // Fallback, though the above should cover all hours
  }
};

export const trimSpaces = sentence => {
  return sentence.trim();
};
export const imageLink = file => {
  if (typeof file === 'string') {
    if (file.includes('http')) {
      return file;
    } else {
      return process.env.REACT_APP_BACKEND_URI + '/artist/images/' + file;
    }
  } else {
    return file;
  }
};

export const extractIdArtist = link => {
  if (link && link.includes('https://open.spotify.com/artist/')) {
    let id = link?.split('https://open.spotify.com/artist/')[1]?.split('/')[0];
    return id;
  }
  return undefined;
};

export const formatNumberWithCommas = number => {
  if (number) {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
};

export const formatDuration = durationMs => {
  if (!durationMs || Number.isNaN(Number(durationMs))) return '--:--';
  const totalSeconds = Math.floor(Number(durationMs) / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${minutes}:${seconds.toString().padStart(2, '0')}`;
};

function formatNumber(value) {
  let number = Number(value);
  if (number >= 1000000) {
    return (number / 1000000).toFixed(1).replace(/\.0$/, '') + 'M'; // Format for millions
  } else if (number >= 1000) {
    return (number / 1000).toFixed(1).replace(/\.0$/, '') + 'K'; // Format for thousands
  } else {
    return number.toString(); // Return the number as is for values less than 1000
  }
}

export const ONE_TIME_CAMPAIGN_TYPE = 'one time';
export const PER_MONTH_CAMPAIGN_TYPE = 'per month';
export const MONTHLY_SUBSCRIPTION_DISCOUNT = 0.1;

export const CAMPAIGN_ANCHOR_TIERS = [
  {
    id: 'launch',
    name: 'Launch',
    budget: 250,
    streamRangeLabel: '8k - 10k',
    mostPopular: false,
    img: bronze,
    platinumStyle: false,
  },
  {
    id: 'growth',
    name: 'Growth',
    budget: 500,
    streamRangeLabel: '18k - 22k',
    mostPopular: true,
    img: sliver,
    platinumStyle: false,
  },
  {
    id: 'scale',
    name: 'Scale',
    budget: 1000,
    streamRangeLabel: '40k - 48k',
    mostPopular: false,
    img: gold,
    platinumStyle: false,
  },
  {
    id: 'ultimate',
    name: 'Ultimate',
    budget: 2500,
    streamRangeLabel: '115k - 135k',
    mostPopular: false,
    img: patinum,
    platinumStyle: true,
  },
];

export const isMonthlyCampaignType = campaignType =>
  String(campaignType || '')
    .trim()
    .toLowerCase() === PER_MONTH_CAMPAIGN_TYPE;

export const calculateMonthlyCharge = budget => {
  const normalizedBudget = Number(budget);
  if (!Number.isFinite(normalizedBudget) || normalizedBudget <= 0) {
    return 0;
  }
  return Math.round(normalizedBudget * (1 - MONTHLY_SUBSCRIPTION_DISCOUNT) * 100) / 100;
};

export function calculateStreamsFromBudget(budget) {
  const price = Number(budget);
  if (price >= 100 && price < 500) {
    return Math.round(price / 0.03);
  } else if (price >= 500 && price < 1000) {
    return Math.round(price / 0.025);
  } else if (price >= 1000 && price < 2500) {
    return Math.round(price / 0.0225);
  } else if (price >= 2500 && price <= 5000) {
    return Math.round(price / 0.02);
  }
  return Math.round(price / 0.03);
}

export function calculateStreamsForPrice(price) {
  if (price) {
    const streams = calculateStreamsFromBudget(price);
    return {
      text: `${formatNumberWithCommas(streams)}`,
      sumOfStreams: `${formatNumber(streams)}`,
    };
  } else {
    return {
      text: `Estimated`,
      sumOfStreams: ``,
    };
  }
}

export function calculateStreamRangeFromBudget(budget) {
  const mid = calculateStreamsFromBudget(budget);
  const min = Math.round(mid * 0.9);
  const max = Math.round(mid * 1.1);
  return {
    mid,
    min,
    max,
    label: `${formatNumber(min)} - ${formatNumber(max)}`,
  };
}

export const formatEstimatedStreams = streamsLabel => `${streamsLabel} streams est.`;

export function buildDailyStreamProjection(budget, days = 30) {
  const { min: totalMin, max: totalMax } = calculateStreamRangeFromBudget(budget);
  const rawWeights = [];

  for (let day = 0; day <= days; day += 1) {
    if (day === 0) {
      rawWeights.push(0);
      continue;
    }

    if (day <= 4) {
      rawWeights.push(day / 4);
    } else {
      rawWeights.push(1 + Math.sin(day * 0.65) * 0.05);
    }
  }

  const activeWeightSum = rawWeights.slice(1).reduce((sum, weight) => sum + weight, 0);
  const points = rawWeights.map((weight, day) => {
    if (day === 0) {
      return { day, min: 0, max: 0 };
    }

    return {
      day,
      min: Math.round((totalMin / activeWeightSum) * weight),
      max: Math.round((totalMax / activeWeightSum) * weight),
    };
  });

  const reconcileTotal = key => {
    const currentTotal = points.slice(1).reduce((sum, point) => sum + point[key], 0);
    const drift = (key === 'min' ? totalMin : totalMax) - currentTotal;
    if (drift !== 0) {
      points[points.length - 1][key] += drift;
    }
  };

  reconcileTotal('min');
  reconcileTotal('max');

  return points;
}

export function calculateAverageDailyStreams(budget, days = 30) {
  const { mid, min, max } = calculateStreamRangeFromBudget(budget);
  return {
    mid: Math.round(mid / days),
    min: Math.round(min / days),
    max: Math.round(max / days),
  };
}

export const packages = [
  {
    img: bronze,
    name: 'Bronze',
    startPrice: 100,
    endPrice: 450,
    discount: 0,
    estimateStreams: '3k - 13k',
  },
  {
    img: sliver,
    name: 'Silver',
    startPrice: 500,
    endPrice: 950,
    discount: 16.67,
    estimateStreams: '20k - 36k',
  },
  {
    img: gold,
    name: 'Gold',
    startPrice: 1000,
    endPrice: 2450,
    discount: 25,
    estimateStreams: '44k - 106k',
  },
  {
    img: patinum,
    name: 'Platinum',
    startPrice: 2500,
    endPrice: 5000,
    discount: 33.33,
    estimateStreams: '125k - 250k',
  },
];
export const getFormattedSpotifyUrl = url => {
  const regex = /\/artist\/([a-zA-Z0-9]+)/; // Regex to match artist ID
  const match = url.match(regex);

  if (match && match[1]) {
    const artistId = match[1];
    return `https://open.spotify.com/artist/${artistId}/discography/single`;
  } else {
    throw new Error('Invalid Spotify URL: Unable to extract artist ID');
  }
};
